module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/25cd71063469498df7cab179156d87b2.png";